export default __webpack_public_path__ + "locales/zh-CN/JavascriptSdk.json?hash=b44ab9de51b57b58f9e3e9f236379d1e";